"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var recompose_1 = require("recompose");
var styled_components_1 = require("styled-components");
var omit_1 = tslib_1.__importDefault(require("lodash/omit"));
var Box_1 = require("../Box");
var StyledTabs_1 = require("./StyledTabs");
var TabsInner = /** @class */ (function (_super) {
    tslib_1.__extends(TabsInner, _super);
    function TabsInner() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            activeIndex: 0
        };
        _this.activateTab = function (index) {
            var _a = _this.props, activeIndex = _a.activeIndex, onActive = _a.onActive;
            if (activeIndex === undefined) {
                _this.setState({ activeIndex: index });
            }
            if (onActive) {
                onActive(index);
            }
        };
        return _this;
    }
    TabsInner.getDerivedStateFromProps = function (nextProps, prevState) {
        var activeIndex = nextProps.activeIndex;
        var stateActiveIndex = prevState.activeIndex;
        if (stateActiveIndex !== activeIndex && activeIndex !== undefined) {
            return { activeIndex: activeIndex };
        }
        return { activeIndex: stateActiveIndex || 0 };
    };
    TabsInner.prototype.render = function () {
        var _this = this;
        var _a = this.props, children = _a.children, flex = _a.flex, justify = _a.justify, tabContents = _a.messages.tabContents, theme = _a.theme, fixedHeadingWidth = _a.fixedHeadingWidth, rest = tslib_1.__rest(_a, ["children", "flex", "justify", "messages", "theme", "fixedHeadingWidth"]);
        var activeIndex = this.state.activeIndex;
        var activeContent;
        var activeTitle;
        var tabs = React.Children.map(children, function (tab, index) {
            if (!tab) {
                return undefined;
            }
            var tabProps = tab.props || {};
            var isTabActive = index === activeIndex;
            if (isTabActive) {
                activeContent = tabProps.children;
                if (typeof tabProps.title === 'string') {
                    activeTitle = tabProps.title;
                }
                else {
                    activeTitle = index + 1;
                }
            }
            return tab.props.customTab
                ? tab
                : React.cloneElement(tab, {
                    fixedHeadingWidth: fixedHeadingWidth,
                    active: isTabActive,
                    onActivate: function () { return _this.activateTab(index); }
                });
        });
        var tabContentTitle = (activeTitle || '') + " " + tabContents;
        // Safety check
        if (!theme) {
            return null;
        }
        return (React.createElement(StyledTabs_1.StyledTabs, tslib_1.__assign({ key: activeIndex, as: Box_1.Box, role: "tablist", flex: flex }, omit_1.default(rest, ['activeIndex', 'onActive']), { background: theme.tabs.background, className: "styledTabs" }),
            React.createElement(StyledTabs_1.StyledTabsHeader, { className: "styledTabsHeader", as: Box_1.Box, direction: "row", justify: justify, flex: false, wrap: true, fixedHeadingWidth: fixedHeadingWidth }, tabs),
            React.createElement(StyledTabs_1.StyledTabPanel, { flex: flex, "aria-label": tabContentTitle, role: "tabpanel", className: "styledTabPanel" }, activeContent)));
    };
    TabsInner.defaultProps = {
        justify: 'start',
        messages: {
            tabContents: 'Tab Contents'
        },
        responsive: true
    };
    return TabsInner;
}(React.Component));
/** @component */
exports.Tabs = recompose_1.compose(styled_components_1.withTheme)(TabsInner);
//# sourceMappingURL=Tabs.js.map